<footer class="main-footer">
    <div class="float-right d-none d-sm-block">
        <b>Version</b> 2.0.0
    </div>
    <strong>Copyright &copy; {{copyright()}} <a href="https://7thaven.com">7thaven</a>.</strong> All rights reserved.
</footer>